import React, { FC } from "react";
import { CampaignPrice } from "../../../Model/CampaignPrice.csharp";
import { FeeItem } from "../../Pricing/FeeItem.csharp";
import { getDiscount } from "../Booking/Helpers/totalPriceCalculator";
import {formatPrice} from "../Helpers/priceHelper";

interface BaseFeesWithCampaignProps {
  baseFees: FeeItem[];
  campaign?: CampaignPrice;
  isWeekendOrHoliday: boolean;
  isEvening: boolean;
}

export const BaseFeesWithCampaignLegacy: FC<BaseFeesWithCampaignProps> = ({
  baseFees,
  campaign,
  isWeekendOrHoliday,
  isEvening,
}) => {
  const campaignComponent = !!campaign && (
    <tr className="pricing-details-row">
      <th className="fw-normal">{campaign.discountPriceLabel ?? "Rabatt"}</th>
      <td className="text-end text-nowrap">
        -{formatPrice(getDiscount(isWeekendOrHoliday, isEvening, campaign))}
      </td>
    </tr>
  );

  const baseFeesComponent = baseFees.map((fee, i) => (
    <tr key={i} className="pricing-details-row">
      <th className="fw-normal">{fee.label}</th>
      {fee.regularPrice != 0 && (
        <td className="text-end text-nowrap">{formatPrice(fee.regularPrice)}</td>
      )}
    </tr>
  ));

  return !!campaign?.showBeforeBaseFees ? (
    <>
      {campaignComponent}
      {baseFeesComponent}
    </>
  ) : (
    <>
      {baseFeesComponent}
      {campaignComponent}
    </>
  );
};
